import { parseQuery } from '@calendly/http-tools'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { URL_STATE_PREFIX } from './constants'
import { parseState } from './helpers'

export const useCurrentUrlScope = (prefix = URL_STATE_PREFIX.RIGHT_RAIL) => {
  const { search } = useLocation()

  const scope = useMemo(() => parseQuery(search), [search])

  const state = scope[`${prefix}State`]
  const scopeName = scope[prefix]
  const [error, props] = useMemo(() => parseState(state), [state])

  return useMemo(
    () => ({
      [prefix]: scopeName,
      [`${prefix}State`]: error ? null : state,
      [`${prefix}Props`]: error ? {} : props,
      error,
    }),
    [prefix, scopeName, state, error, props],
  )
}
